import React, { useEffect, useMemo, useState } from 'react';
import { FileDown, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { api, downloadFile, errMsg } from '../../api';
import ConsoleKpis from './ConsoleKpis';
import ConsoleCharts from './ConsoleCharts';
import InfraMap, { useWorld } from './InfraMap';
import DomainPanel from './DomainPanel';
import InfraForm from './InfraForm';
import CriPanel from './CriPanel';
import VulnPanel from './VulnPanel';
import './soc.css';

export default function CyberConsole({ doc, devices }) {
  const [data, setData] = useState(null);
  const [sel, setSel] = useState(null);
  const geo = useWorld();
  const reload = () => api.get('/cyber/console').then((r) => { setData(r.data); setSel((s) => (r.data.domains.some((d) => d.id === s) ? s : r.data.domains[0]?.id || null)); }).catch(() => setData({ infra: { sites: [] }, domains: [] }));
  useEffect(() => { reload(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const countries = useMemo(() => (geo?.features || []).map((f) => [f.id, f.properties.name]).sort((a, b) => a[1].localeCompare(b[1])), [geo]);
  if (!data) return <div className="py-16 grid place-items-center"><Loader2 className="animate-spin text-[#D4AF37]" /></div>;
  const name = Object.fromEntries(countries);
  const sites = (data.infra.sites || []).map((s) => ({ ...s, country_name: name[s.country] }));
  const infra = { ...data.infra, sites };
  const servers = data.domains.flatMap((d) => d.last?.servers || []);
  const index = data.index || {};
  const pdf = () => downloadFile('/cyber/console/pdf', 'BOND_Console_Cyber_Security.pdf').catch((e) => toast.error(errMsg(e)));
  return (
    <section className="soc p-4 sm:p-5 soc-rise" data-testid="devices-console">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <p className="soc-mono text-sm font-semibold tracking-[0.2em] text-[#00F0FF] inline-flex items-center gap-2"><span className="soc-led" style={{ color: '#00FF87' }} />CONSOLE DI MONITORAGGIO</p>
        <div className="flex flex-wrap items-center gap-3"><p className="soc-mono text-[10px] soc-muted">{data.domains.length} DOMINI · {servers.length} SERVER · SCANSIONE SETTIMANALE ATTIVA</p>
          <button onClick={pdf} className="soc-ghost h-8 px-3 text-xs soc-mono" data-testid="console-pdf-btn"><FileDown size={13} />REPORT PDF</button></div>
      </div>
      <ConsoleKpis score={index.total} parts={index} doc={doc} infra={infra} devices={devices} servers={servers} />
      <ConsoleCharts dom={data.domains.find((d) => d.id === sel)} devices={devices} />
      <VulnPanel vapt={data.vapt} />
      <CriPanel cri={data.cri} pending={data.cri_pending} />
      <InfraMap servers={servers} sites={sites} geo={geo} />
      <DomainPanel domains={data.domains} sel={sel} setSel={setSel} reload={reload} />
      <InfraForm key={data.infra.updated_at || 'new'} infra={data.infra} countries={countries} onSaved={reload} />
    </section>
  );
}
